module.exports = __webpack_public_path__ + "img/about-illustration-mobile.9f963e3a.png";